var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step2"},[_c('h2',{staticClass:"access_hidden"},[_vm._v("전환금액 입력")]),_c('exchange-point-info'),_c('exchange-point',{on:{"btnState":_vm.btnState}}),_c('exchange-notice'),_c('div',{staticClass:"bt"},[_c('v-button',{staticClass:"btn01",attrs:{"text":"다음","disabled":_vm.btnDisabled},on:{"handleClick":_vm.handleClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }